import Seo from "@/components/Seo";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSite, siteText } from "@/context/SiteContext";
import { toImageUrl } from "@/lib/driveUrl";

const BADGE_STYLES = ["bg-[#B83227]", "bg-[#E67E22]", "bg-[#1E1B18]", "bg-[#B83227]"];
const BADGE_LETTERS = ["A", "B", "C", "D"];

export default function Prestations() {
  const [prestations, setPrestations] = useState([]);
  const { settings } = useSite();

  useEffect(() => {
    api.get("/prestations").then((r) => setPrestations(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <Seo title="Prestations" description="Bals trad, concerts, initiations aux danses et cérémonies : les formules des Sonneurs de la Côte pour mairies, associations, festivals et événements privés." path="/prestations" />
      <section className="border-b border-stone-200 bg-[#1E1B18] py-16 text-white">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-200">{siteText(settings, "page_prestations_label", "Nos animations")}</span>
          <h1 className="mt-2 font-display text-4xl font-bold uppercase tracking-tight sm:text-6xl">{siteText(settings, "page_prestations_title", "Prestations")}</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-stone-300 sm:text-base">
            {siteText(settings, "page_prestations_intro", "Bals trad, initiations aux danses traditionnelles, accompagnement de cérémonies de commémoration et stages de musique trad : quatre formules pensées pour les mairies, les associations, les festivals et les particuliers.")}
          </p>
        </div>
      </section>

      <section className="bg-[#FAF6F0] py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {prestations.map((p, i) => (
              <article
                key={p.id}
                data-testid={`prestation-card-${i}`}
                className="flex flex-col overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm transition-transform duration-300 hover:-translate-y-1"
              >
                {p.image_url && (
                  <div className="relative h-52 overflow-hidden" data-image-container>
                    <img src={toImageUrl(p.image_url)} alt={p.title} loading="lazy" onError={(e) => (e.currentTarget.closest("[data-image-container]").style.display = "none")} className="h-full w-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    <div
                      className={`absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded font-display text-lg font-bold text-white ${BADGE_STYLES[i % 4]}`}
                    >
                      {BADGE_LETTERS[i % 4]}
                    </div>
                  </div>
                )}
                <div className="flex flex-1 flex-col justify-between p-6">
                  <div>
                    {!p.image_url && (
                      <div
                        className={`mb-4 flex h-10 w-10 items-center justify-center rounded font-display text-lg font-bold text-white ${BADGE_STYLES[i % 4]}`}
                      >
                        {BADGE_LETTERS[i % 4]}
                      </div>
                    )}
                    <h2 className="mb-3 font-display text-2xl font-bold uppercase text-[#1E1B18]">{p.title}</h2>
                    <p className="text-sm leading-relaxed text-stone-600">{p.description}</p>
                  </div>
                  {p.bookable !== false && (
                    <div className="mt-6 border-t border-stone-100 pt-4">
                      <Link
                        to="/contact"
                        data-testid={`prestation-booking-link-${i}`}
                        className="text-xs font-bold uppercase text-[#B83227] hover:underline"
                      >
                        {siteText(settings, "page_prestations_card_link", "Demander cette prestation →")}
                      </Link>
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>

          <div className="mt-16 rounded-2xl bg-[#1E1B18] p-8 text-center text-white sm:p-12">
            <h2 className="font-display text-2xl font-bold uppercase sm:text-3xl">{siteText(settings, "prestas_box_title", "Une envie particulière ?")}</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-stone-300">
              {siteText(settings, "prestas_box_text", "Chaque événement est unique : parlez-nous de votre projet et nous construisons une animation sur mesure.")}
            </p>
            <Link
              to="/contact"
              data-testid="prestations-cta-button"
              className="mt-6 inline-block rounded bg-[#B83227] px-8 py-3.5 text-sm font-bold uppercase tracking-wider text-white shadow transition-colors duration-300 hover:bg-[#96281E]"
            >
              {siteText(settings, "prestas_box_button", "Nous écrire")}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
